// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoBlock_wrapper__s+kT5"};